// Roles and permissions (docs/architecture.md §10). This map is the v0 policy; Cedar replaces
// the evaluation later, but these names are the contract shared by the API, web and mobile.
export const AGENCY_ROLES = [
    'owner',
    'admin',
    'coordinator',
    'care_manager',
    'billing',
    'caregiver',
];
export const PERMISSIONS = [
    'org_unit:read',
    'org_unit:create',
    'user:read',
    'user:manage',
];
const ROLE_PERMISSIONS = {
    owner: ['org_unit:read', 'org_unit:create', 'user:read', 'user:manage'],
    admin: ['org_unit:read', 'org_unit:create', 'user:read', 'user:manage'],
    coordinator: ['org_unit:read', 'user:read'],
    care_manager: ['org_unit:read'],
    billing: ['org_unit:read'],
    caregiver: ['org_unit:read'],
};
export function isRole(value) {
    return AGENCY_ROLES.includes(value);
}
/** Permissions granted by a set of roles; unknown role names grant nothing. */
export function permissionsFor(roles) {
    return new Set(roles.filter(isRole).flatMap((role) => ROLE_PERMISSIONS[role]));
}
/** How far a membership reaches: just its node, or the node and its descendants. */
export const MEMBERSHIP_SCOPES = ['node', 'subtree'];
export const ORG_UNIT_TYPES = [
    'agency',
    'region',
    'branch',
    'team',
    'franchisor',
    'franchisee',
    'household',
];
/**
 * Consecutive failed sign-ins (wrong password or wrong 2-step code) before an account is locked.
 * A locked account stays locked until an admin unlocks it, which also forces a password reset.
 */
export const MAX_FAILED_SIGN_INS = 10;
//# sourceMappingURL=access.js.map